import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_CMG_STATUS_SUCCESS,
  GET_CMG_STATUS_FAILURE,
  GET_CMG_STATUS_LOADING,
  GET_CMG_STATUS_RESET,
} = therapyPlanningAction;

export type CmgStatus = 'LOW' | 'HIGH' | 'NORMAL' | null;

export type CmgWeekStatus = {
  ptOtCmgStatus: CmgStatus;
  slpCmgStatus: CmgStatus;
};

// The planner shows one verdict per therapy week and can have more than one week on screen, so
// verdicts are stored per week key ('<weekStart>_<weekEnd>') rather than as a single response.
const intialState: any = {
  statusByWeek: {},
  loadingWeeks: {},
};

export const getCmgStatusReducer = (state = intialState, action: any) => {
  const weekKey = action?.payload?.weekKey;

  switch (action.type) {
    case GET_CMG_STATUS_LOADING: {
      if (!weekKey) return state;
      return {
        ...state,
        loadingWeeks: { ...state.loadingWeeks, [weekKey]: true },
      };
    }

    case GET_CMG_STATUS_SUCCESS: {
      if (!weekKey) return state;
      return {
        ...state,
        statusByWeek: {
          ...state.statusByWeek,
          [weekKey]: {
            ptOtCmgStatus: action?.payload?.data?.ptOtCmgStatus ?? null,
            slpCmgStatus: action?.payload?.data?.slpCmgStatus ?? null,
          },
        },
        loadingWeeks: { ...state.loadingWeeks, [weekKey]: false },
      };
    }

    case GET_CMG_STATUS_FAILURE: {
      if (!weekKey) return state;
      // Drop the week entirely rather than leaving a stale verdict on screen.
      const { [weekKey]: _removed, ...statusByWeek } = state.statusByWeek;
      return {
        ...state,
        statusByWeek,
        loadingWeeks: { ...state.loadingWeeks, [weekKey]: false },
      };
    }

    case GET_CMG_STATUS_RESET:
      return intialState;

    default:
      return state;
  }
};
